import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const teamRolesNavigatedEventSchema = z.object({
  entityUrn: z.string().describe('The URN of the entity.'),
});

export type TeamRolesNavigatedEvent = z.infer<
  typeof teamRolesNavigatedEventSchema
>;

export const teamRolesNavigatedTopic = createTopic<TeamRolesNavigatedEvent>(
  {
    namespace: 'control-plane',
    name: 'team-roles-navigated',
    description: 'User navigated to the project team roles page',
  },
  teamRolesNavigatedEventSchema,
  s => [{ action: ConfigActions.HASH, path: s.entityUrn }],
);
